import type { NotFoundRouteProps } from "@tanstack/react-router";
import { useEffect } from "react";
import ErrorLayout from "./ErrorOrNotFoundPage";

const NotFoundPage = (props: NotFoundRouteProps) => {
  useEffect(() => {
    // Prerender.io turns this into a real 404 for crawlers; the robots tag
    // covers the ones that render the SPA themselves and never see it.
    const tags = [
      { name: "prerender-status-code", content: "404" },
      { name: "robots", content: "noindex, nofollow" },
    ].map(({ name, content }) => {
      const meta = document.createElement("meta");
      meta.name = name;
      meta.content = content;
      document.head.appendChild(meta);
      return meta;
    });

    return () => {
      tags.forEach((meta) => meta.remove());
    };
  }, []);

  return (
    <ErrorLayout title="Oops, nothing found" showReset={false} {...props} />
  );
};

export default NotFoundPage;
